export class DegreeResultDto {
    shool: string;
    campus: string;
    degree: string;

    get school(): string {
        return this.shool;
    }
}
